

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import PortletLabel from 'components/PortletLabel';
import PortletFooter from 'components/PortletFooter';
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import CircularProgress from '@material-ui/core/CircularProgress';
//import {HarFileView} from 'react-perfcascade';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { Grid, TableRow, TableCell, Divider, Table, TableHead, TableBody } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField/index';

import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import { api_host, api_auth } from './../../common/globals/constants';
// Component styles

import moment from 'moment'
import 'moment/locale/es'
import PerfectScrollbar from 'react-perfect-scrollbar';
import {StickyTable, Row, Cell} from 'react-sticky-table';
moment.locale('es')
const dateMoment=((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))
const sendValues = (value, nombre, descripcion, token, user, weekdaysEnabled, horarioId) => {

    return new Promise(resolve => {
        setTimeout(() => {
        fetch(api_host+`/reporte/general/horarios_habiles/?token=${token}&start=${new Date().getTime()}`, {
            method: 'PATCH', // or 'PUT'
            body: JSON.stringify({token: token, nombre: nombre, descripcion: descripcion, horario_tipo_id: value, cliente_id: user, weekdaysEnabled:weekdaysEnabled, horario_id: horarioId}), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .catch(error => console.error('Error:', error))
            .then(response => {
                if (response.status == 0) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            }
            );
        }, 100);
    });
};


class HoursEdit extends Component {
    
    constructor(props) {
        super(props);
        const { t } = props || {};
        this.state = {
            isLoad:true,
            dates:null,
            modalOpen:false,
            weekdays: [
                (t ? t('hours.weekdays.monday') : 'Lunes'),
                (t ? t('hours.weekdays.tuesday') : 'Martes'),
                (t ? t('hours.weekdays.wednesday') : 'Miércoles'),
                (t ? t('hours.weekdays.thursday') : 'Jueves'),
                (t ? t('hours.weekdays.friday') : 'Viernes'),
                (t ? t('hours.weekdays.saturday') : 'Sábado'),
                (t ? t('hours.weekdays.sunday') : 'Domingo'),
                ''
            ],
            hours:['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', 
                    '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', 
                    '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
            weekdaysEnabled: [{'name':'Lunes','status':'disabled', 'id':1, 'hoursEnabled':[
                    {'name':'00:00', 'status':'disabled'}, {'name':'01:00', 'status':'disabled'}, 
                    {'name':'02:00', 'status':'disabled'}, {'name':'03:00', 'status':'disabled'}, 
                    {'name':'04:00', 'status':'disabled'}, {'name':'05:00', 'status':'disabled'},
                    {'name':'06:00', 'status':'disabled'}, {'name':'07:00', 'status':'disabled'}, 
                    {'name':'08:00', 'status':'disabled'}, {'name':'09:00', 'status':'disabled'}, 
                    {'name':'10:00', 'status':'disabled'}, {'name':'11:00', 'status':'disabled'}, 
                    {'name':'12:00', 'status':'disabled'}, {'name':'13:00', 'status':'disabled'}, 
                    {'name':'14:00', 'status':'disabled'}, {'name':'15:00', 'status':'disabled'}, 
                    {'name':'16:00', 'status':'disabled'}, {'name':'17:00', 'status':'disabled'}, 
                    {'name':'18:00', 'status':'disabled'}, {'name':'19:00', 'status':'disabled'}, 
                    {'name':'20:00', 'status':'disabled'}, {'name':'21:00', 'status':'disabled'},
                    {'name':'22:00', 'status':'disabled'}, {'name':'23:00', 'status':'disabled'}, '']}, 
                    {'name':'Martes','status':'disabled', 'id':2, 'hoursEnabled':[
                    {'name':'00:00', 'status':'disabled'}, {'name':'01:00', 'status':'disabled'}, 
                    {'name':'02:00', 'status':'disabled'}, {'name':'03:00', 'status':'disabled'}, 
                    {'name':'04:00', 'status':'disabled'}, {'name':'05:00', 'status':'disabled'},
                    {'name':'06:00', 'status':'disabled'}, {'name':'07:00', 'status':'disabled'}, 
                    {'name':'08:00', 'status':'disabled'}, {'name':'09:00', 'status':'disabled'}, 
                    {'name':'10:00', 'status':'disabled'}, {'name':'11:00', 'status':'disabled'}, 
                    {'name':'12:00', 'status':'disabled'}, {'name':'13:00', 'status':'disabled'}, 
                    {'name':'14:00', 'status':'disabled'}, {'name':'15:00', 'status':'disabled'}, 
                    {'name':'16:00', 'status':'disabled'}, {'name':'17:00', 'status':'disabled'}, 
                    {'name':'18:00', 'status':'disabled'}, {'name':'19:00', 'status':'disabled'}, 
                    {'name':'20:00', 'status':'disabled'}, {'name':'21:00', 'status':'disabled'},
                    {'name':'22:00', 'status':'disabled'}, {'name':'23:00', 'status':'disabled'}, '']}, 
                    {'name':'Miércoles','status':'disabled', 'id':3, 'hoursEnabled':[
                    {'name':'00:00', 'status':'disabled'}, {'name':'01:00', 'status':'disabled'}, 
                    {'name':'02:00', 'status':'disabled'}, {'name':'03:00', 'status':'disabled'}, 
                    {'name':'04:00', 'status':'disabled'}, {'name':'05:00', 'status':'disabled'},
                    {'name':'06:00', 'status':'disabled'}, {'name':'07:00', 'status':'disabled'}, 
                    {'name':'08:00', 'status':'disabled'}, {'name':'09:00', 'status':'disabled'}, 
                    {'name':'10:00', 'status':'disabled'}, {'name':'11:00', 'status':'disabled'}, 
                    {'name':'12:00', 'status':'disabled'}, {'name':'13:00', 'status':'disabled'}, 
                    {'name':'14:00', 'status':'disabled'}, {'name':'15:00', 'status':'disabled'}, 
                    {'name':'16:00', 'status':'disabled'}, {'name':'17:00', 'status':'disabled'}, 
                    {'name':'18:00', 'status':'disabled'}, {'name':'19:00', 'status':'disabled'}, 
                    {'name':'20:00', 'status':'disabled'}, {'name':'21:00', 'status':'disabled'},
                    {'name':'22:00', 'status':'disabled'}, {'name':'23:00', 'status':'disabled'}, '']}, 
                    {'name':'Jueves','status':'disabled', 'id':4, 'hoursEnabled':[
                    {'name':'00:00', 'status':'disabled'}, {'name':'01:00', 'status':'disabled'}, 
                    {'name':'02:00', 'status':'disabled'}, {'name':'03:00', 'status':'disabled'}, 
                    {'name':'04:00', 'status':'disabled'}, {'name':'05:00', 'status':'disabled'},
                    {'name':'06:00', 'status':'disabled'}, {'name':'07:00', 'status':'disabled'}, 
                    {'name':'08:00', 'status':'disabled'}, {'name':'09:00', 'status':'disabled'}, 
                    {'name':'10:00', 'status':'disabled'}, {'name':'11:00', 'status':'disabled'}, 
                    {'name':'12:00', 'status':'disabled'}, {'name':'13:00', 'status':'disabled'}, 
                    {'name':'14:00', 'status':'disabled'}, {'name':'15:00', 'status':'disabled'}, 
                    {'name':'16:00', 'status':'disabled'}, {'name':'17:00', 'status':'disabled'}, 
                    {'name':'18:00', 'status':'disabled'}, {'name':'19:00', 'status':'disabled'}, 
                    {'name':'20:00', 'status':'disabled'}, {'name':'21:00', 'status':'disabled'},
                    {'name':'22:00', 'status':'disabled'}, {'name':'23:00', 'status':'disabled'}, '']}, 
                    {'name':'Viernes','status':'disabled', 'id':5, 'hoursEnabled':[
                    {'name':'00:00', 'status':'disabled'}, {'name':'01:00', 'status':'disabled'}, 
                    {'name':'02:00', 'status':'disabled'}, {'name':'03:00', 'status':'disabled'}, 
                    {'name':'04:00', 'status':'disabled'}, {'name':'05:00', 'status':'disabled'},
                    {'name':'06:00', 'status':'disabled'}, {'name':'07:00', 'status':'disabled'}, 
                    {'name':'08:00', 'status':'disabled'}, {'name':'09:00', 'status':'disabled'}, 
                    {'name':'10:00', 'status':'disabled'}, {'name':'11:00', 'status':'disabled'}, 
                    {'name':'12:00', 'status':'disabled'}, {'name':'13:00', 'status':'disabled'}, 
                    {'name':'14:00', 'status':'disabled'}, {'name':'15:00', 'status':'disabled'}, 
                    {'name':'16:00', 'status':'disabled'}, {'name':'17:00', 'status':'disabled'}, 
                    {'name':'18:00', 'status':'disabled'}, {'name':'19:00', 'status':'disabled'}, 
                    {'name':'20:00', 'status':'disabled'}, {'name':'21:00', 'status':'disabled'},
                    {'name':'22:00', 'status':'disabled'}, {'name':'23:00', 'status':'disabled'}, '']}, 
                    {'name':'Sábado','status':'disabled', 'id':6, 'hoursEnabled':[
                    {'name':'00:00', 'status':'disabled'}, {'name':'01:00', 'status':'disabled'}, 
                    {'name':'02:00', 'status':'disabled'}, {'name':'03:00', 'status':'disabled'}, 
                    {'name':'04:00', 'status':'disabled'}, {'name':'05:00', 'status':'disabled'},
                    {'name':'06:00', 'status':'disabled'}, {'name':'07:00', 'status':'disabled'}, 
                    {'name':'08:00', 'status':'disabled'}, {'name':'09:00', 'status':'disabled'}, 
                    {'name':'10:00', 'status':'disabled'}, {'name':'11:00', 'status':'disabled'}, 
                    {'name':'12:00', 'status':'disabled'}, {'name':'13:00', 'status':'disabled'}, 
                    {'name':'14:00', 'status':'disabled'}, {'name':'15:00', 'status':'disabled'}, 
                    {'name':'16:00', 'status':'disabled'}, {'name':'17:00', 'status':'disabled'}, 
                    {'name':'18:00', 'status':'disabled'}, {'name':'19:00', 'status':'disabled'}, 
                    {'name':'20:00', 'status':'disabled'}, {'name':'21:00', 'status':'disabled'},
                    {'name':'22:00', 'status':'disabled'}, {'name':'23:00', 'status':'disabled'}, '']}, 
                    {'name':'Domingo','status':'disabled', 'id':7, 'hoursEnabled':[
                    {'name':'00:00', 'status':'disabled'}, {'name':'01:00', 'status':'disabled'}, 
                    {'name':'02:00', 'status':'disabled'}, {'name':'03:00', 'status':'disabled'}, 
                    {'name':'04:00', 'status':'disabled'}, {'name':'05:00', 'status':'disabled'},
                    {'name':'06:00', 'status':'disabled'}, {'name':'07:00', 'status':'disabled'}, 
                    {'name':'08:00', 'status':'disabled'}, {'name':'09:00', 'status':'disabled'}, 
                    {'name':'10:00', 'status':'disabled'}, {'name':'11:00', 'status':'disabled'}, 
                    {'name':'12:00', 'status':'disabled'}, {'name':'13:00', 'status':'disabled'}, 
                    {'name':'14:00', 'status':'disabled'}, {'name':'15:00', 'status':'disabled'}, 
                    {'name':'16:00', 'status':'disabled'}, {'name':'17:00', 'status':'disabled'}, 
                    {'name':'18:00', 'status':'disabled'}, {'name':'19:00', 'status':'disabled'}, 
                    {'name':'20:00', 'status':'disabled'}, {'name':'21:00', 'status':'disabled'},
                    {'name':'22:00', 'status':'disabled'}, {'name':'23:00', 'status':'disabled'}, '']}, ''],
            completed: false,
            open: false,
            values:{
                nameEdit: this.props.data.nombre,
                descriptionEdit: this.props.data.descripcion
            },
            hoursEdit: this.props.data.horario_items,
            horarioId: this.props.data.horario_id,
            horarioTipo: this.props.data.horario_tipo,
            
        };
    }

    static getDerivedStateFromProps(props, state) {
        /*if (props.dateBegin !== state.begin||props.dateFinal!==state.final) {
            return {
                isLoad:true,
                begin:props.dateBegin,
                final:props.dateFinal,
                dates:null
            }
        }*/
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        /*if(prevProps.dateBegin!== this.state.begin||prevProps.dateFinal!== this.state.final){
            this.processData();
        }*/
    }

    componentDidMount() {
        this.processData();
    }

    /*getFetchs = (objective, begin, final, token) =>{         
        var getData = getAudioPatternList(objective, begin, final, token)           
        getData.then( data =>  { 
            this.setState({
                isLoad:false,
                data:data
            })
        })      
        
    }*/
   
    processData = () => {
        const {hoursEdit, weekdaysEnabled, hoursEnabled} = this.state
        hoursEdit.map((hour , hourkey) => {
            weekdaysEnabled.map((day , daykey) => {
                if (hour['dia_semana'] == day['id']){
                    // start time and end time
                    var startTime = moment(hour['hora_inicio'], "HH:mm:ss");
                    if (hour['hora_termino'] == '00:00:00') {
                        var endTime = moment('24:00:00', "HH:mm:ss");
                    } else{
                        var endTime = moment(hour['hora_termino'], "HH:mm:ss");
                    }
                    var ceroTime = moment('00:00:00', "HH:mm:ss");
                    // calculate total duration
                    var duration = moment.duration(endTime.diff(startTime));
                    var durationCero = moment.duration(startTime.diff(ceroTime));
                    // duration in hours
                    var hours = parseInt(duration.asHours());
                    var minutes = parseInt(duration.asMinutes()); 
                    if ((0 < minutes) && (minutes <= 59)){
                        hours = 1
                    }
                    var hoursCero = parseInt(durationCero.asHours());
                    // duration in minutes
                    //var minutes = parseInt(duration.asMinutes())%60;
                    /*if (hours == 0){
                        hours = 23
                    }*/
                    var cont = 0
                    var hourStart = hour['hora_inicio'].substr(0,5)
                    day.hoursEnabled.map((hourEnabled , hourEnabledkey) => {
                        if (hourStart == hourEnabled['name']){
                            if (cont < hours) {
                                hourEnabled['status'] = 'enabled'
                                cont = cont  + 1
                                if(parseInt(hourStart.substr(0,2))+1 < 10){
                                    hourStart = '0'+(parseInt(hourStart.substr(0,2))+1).toString()+':00'
                                }else{
                                    hourStart = (parseInt(hourStart.substr(0,2))+1).toString()+':00'
                                }
                                
                            }
                        }
                    })
                }
            })
        })
        this.setState({
                isLoad:false,
                //data:data
            })
    }

    
    setOpen = (audio) => {
        this.setState({
            modalOpen : true,
            modalClose : false,
            setAudio : audio,
        })
    }
    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true,
            setAudio : null
        })
    }

    onCellClick = (event) => {
        const newState = { ...this.state };
        const {hoursEnabled, weekdaysEnabled} = this.state;
        var newChecked = [...weekdaysEnabled];
        const currentIndex = newChecked[event.target.title].hoursEnabled[event.target.id]
        if (currentIndex.status == 'enabled'){
            newChecked[event.target.title].hoursEnabled[event.target.id].status = 'disabled'
        } else if(currentIndex.status == 'disabled'){
            newChecked[event.target.title].hoursEnabled[event.target.id].status = 'enabled'
        }
        newState['weekdaysEnabled'] = newChecked
        this.setState(newState);
    }
    onColumnClick = (event) => {
        const newState = { ...this.state };
        const {hoursEnabled, weekdaysEnabled} = this.state;
        var newChecked = [...weekdaysEnabled];
        newChecked.map((day , daykey) => {
            if (day != ''){
                day.hoursEnabled.map((hourEnabled, hourEnabledkey) => {
                    if (hourEnabled != ''){
                        if (hourEnabledkey == event.target.id){
                            if (hourEnabled['status'] == 'enabled'){
                                hourEnabled['status'] = 'disabled'
                            } else {
                                hourEnabled['status'] = 'enabled'
                            }
                        }
                    }
                    
                })
            }
        })
        newState['weekdaysEnabled'] = newChecked
        this.setState(newState);
    }
    onRowClick = (event) => {
        const newState = { ...this.state };
        const {hoursEnabled, weekdaysEnabled} = this.state;
        var newChecked = [...weekdaysEnabled];
        newChecked.map((day , daykey) => {
            if (day != ''){
                day.hoursEnabled.map((hourEnabled, hourEnabledkey) => {
                    if (hourEnabled != ''){
                        if (daykey == event.target.id){
                            if (hourEnabled['status'] == 'enabled'){
                                hourEnabled['status'] = 'disabled'
                            } else {
                                hourEnabled['status'] = 'enabled'
                            }
                        }
                    }
                    
                })
            }
        })
        newState['weekdaysEnabled'] = newChecked
        this.setState(newState);
    }

    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    validateName = (nameEdit) => {
        if (!nameEdit) {
            this.setState({
                validName: true,
            });
        } else {
            this.setState({
                validName: false,
            });
        }
    }
    validateDescription = (description) => {
        if (!description) {
            this.setState({
                validDescription: true,
            });
        } else {
            this.setState({
                validDescription: false,
            });
        }
    }

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.values[field] = value;   
        this.setState(newState);
    };

    handleSaved = async (value) => {
        const {values, weekdaysEnabled, horarioId} = this.state
        const {closeModal } = this.props;
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('client_id')
        if (Object.keys(values).length > 0) {
            var nombre = values.nameEdit
            var descripcion = values.descriptionEdit
            var value = 5 
           
            var ok = await sendValues(value, nombre, descripcion, token, user, weekdaysEnabled, horarioId);
            if (ok){
                this.setState({
                    //isLoading: true,
                    isValid: true,                   
                    openSnack: true,
                    editEl: null,
                    addEl: null,
                    validEmail: false,
                    validName: false,
                });
                this.props.handleOpenSnack(true)
                //handleShowSnack(true)
                //this.getDataFromAPI();
                setTimeout(() => {this.setCloseModal();},1000)
            } else {
                this.props.handleOpenSnack(false)
                //handleShowSnack(false)
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    openSnack: true,
                });  
            }
        } else {
            this.props.handleOpenSnack(false)
            //handleShowSnack(false)
            this.setState({
                isLoading: false,
                isValid: false,                   
                openSnack: true
            });
        }
    };
    setCloseModal=()=>{
        //const {closeModal} = this.props;
        this.props.closeModal()  
    }
    render() {

        const { isLoad, data, steps, objective, modalOpen, onClose, weekdays, hours, weekdaysEnabled, hoursEnabled, validName, open, values, horarioTipo} = this.state;
    const { classes, states, openModal, closeModal, t } = this.props;
        const showModal = Boolean(open); 
        return(<Portlet>
                <PortletHeader style={{backgroundColor:'#525252', color:'white', borderTopLeftRadius: 'inherit', borderTopRightRadius: 'inherit'}}>
                    <Typography 
                        variant="h3"
                        //title="Detalle Patrones"                                        
                    >{t('hours.title.information')}</Typography>
                    <IconButton 
                        key="close" 
                        aria-label="close" 
                        style={{color:"white", float:"right"}}
                        onClick={closeModal}>
                            <CloseIcon/>
                    </IconButton>
                </PortletHeader>
                <PortletContent>
                    <form className={classes.form}>
                        <Grid container spacing={2}>
                            <Grid item lg={3} md={3} sm={12} xs={12}>
                                <TextField
                                    className={classes.textField}
                                    label={t('hours.label.name')}
                                    name="nameEdit"
                                    onChange={event =>
                                        this.handleFieldChange('nameEdit', event.target.value)
                                    }
                                    type="text"
                                    required
                                    onBlur={event =>
                                        this.validateName(event.target.value)
                                    }
                                    defaultValue={values.nameEdit}
                                    error={validName}
                                    helperText={validName ? t('hours.validation.name.required') : ''}
                                    variant="outlined"
                                    inputProps={{maxLength :40}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item lg={3} md={3} sm={12} xs={12}>
                                <TextField
                                    className={classes.textField}
                                    label={t('hours.label.description')}
                                    name="descriptionEdit"
                                    onChange={event =>
                                        this.handleFieldChange('descriptionEdit', event.target.value)
                                    }
                                    type="text"
                                    //required
                                    onBlur={event =>
                                        this.validateDescription(event.target.value)
                                    }
                                    defaultValue={values.descriptionEdit}
                                    //error={validDescription}
                                    //helperText={validDescription ? 'Por favor ingrese una descripción válida' : ' '}
                                    variant="outlined"
                                    inputProps={{maxLength :40}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item lg={3} md={3} sm={12} xs={12}>
                                <TextField
                                    className={classes.textField}
                                    label={t('hours.label.type')}
                                    name="type"
                                    type="text"
                                    value={t(`horario-tipo.${horarioTipo['horario_tipo_id']}.name`, {defaultValue: 'N/I'})}
                                    variant="outlined"
                                    disabled={true}
                                    InputProps={{
                                        classes:{
                                            root: classes.inputRoot,
                                            disabled: classes.disabled
                                        }
                                    }}
                                    InputLabelProps={{
                                        classes: {
                                            root: classes.labelRoot,
                                            disabled: classes.disabled
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </form>
                </PortletContent>
            {isLoad ?
                <PortletContent>
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"
                        size={12}
                        thickness={3}
                    />
                        {t('hours.loading')}
                    </Typography>
                </PortletContent>
            :
            <Portlet>
            <PortletHeader style={{backgroundColor:'#525252', color:'white'}}>
                    <Typography 
                        variant="h3"
                        //title="Detalle Patrones"                                        
                    >{t('hours.title.configuration')}</Typography>
                </PortletHeader>
                <PortletContent className={classes.popoverPorlet}> 
                <Typography variant="body1" className={classes.textColorPopover} >
                    {t('hours.help.associate')}
                </Typography> 
                <Typography variant="body1" className={classes.textColorPopover} >
                    {t('hours.help.icons')}
                </Typography> 
            </PortletContent>
                <PerfectScrollbar>
                <PortletContent  style={{padding:'0px'}}>
                    <StickyTable leftStickyColumnCount={1}>
                        <Row>
                            <Cell style={{backgroundColor:'#525252', width:'10px'}}></Cell>
                            {hours.map(hour => (
                                <Cell style={{border: '1px solid #e5e5e5', backgroundColor:'#525252'}}><Typography style={{color:'white'}}>{hour}</Typography></Cell>
                                ))
                            }
                        </Row>
                        {weekdays.map((day, daykey) => (
                            day == '' ?
                                <Row>
                                    <Cell style={{backgroundColor:'white', width:'10px'}}></Cell>
                                    {hours.map((hour , hourkey) => (
                                        <Cell title={daykey} id={hourkey} style={{border: '1px solid #e5e5e5', backgroundColor:'#ebebeb', paddingLeft:'23px'}} onClick={this.onColumnClick.bind(this)}>{'▲'}</Cell>
                                    ))}
                                </Row>
                            :
                                <Row>
                                    <Cell style={{backgroundColor:'#525252'}}><Typography style={{color:'white'}}>{day}</Typography></Cell> 
                                    {weekdaysEnabled[daykey].hoursEnabled.map((hour , hourkey) => (
                                        hour == '' ?
                                        <Cell title={daykey} id={daykey} style={{border: '1px solid #e5e5e5', backgroundColor:'#ebebeb'}} onClick={this.onRowClick.bind(this)}>{'◄'}</Cell>
                                        : 
                                        <Cell title={daykey} id={hourkey} style={{border: '1px solid #e5e5e5', backgroundColor: weekdaysEnabled[daykey].hoursEnabled[hourkey].status == 'enabled' ? '#f58b32' :'#ebebeb'}} onClick={this.onCellClick}></Cell>
                                    ))
                                    }
                                </Row>
                            ))
                        }
                    </StickyTable>
                </PortletContent></PerfectScrollbar></Portlet>}
                <PortletFooter align="center">
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={this.handleSaved}
                    >
                        {t('hours.button.update')}
                    </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={closeModal}
                    >
                        {t('hours.button.cancel')}
                    </Button>
                </PortletFooter>
            </Portlet> 
                    
        ) 
    }
}



export default compose(withRouter, withStyles(styles), withTranslation())(HoursEdit);